import React from 'react';
import { UsersIcon, UserIcon, CheckCircle2Icon } from 'lucide-react';
export function MembershipTypes() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2163">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2164">
        <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6 text-center" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#1e3d2f'
      }} data-id="element-2165">
          Membership Types
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2166">
          {/* Family Membership */}
          <div className="bg-white rounded-xl p-8 border shadow-sm flex flex-col relative overflow-hidden" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2167">
            <div className="absolute top-0 left-0 right-0 h-1" style={{
            backgroundColor: '#1e3d2f'
          }} data-id="element-2168" />
            <div className="flex items-center gap-3 mb-4" data-id="element-2169">
              <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{
              backgroundColor: 'rgba(30,61,47,0.1)'
            }} data-id="element-2170">
                <UsersIcon size={24} style={{
                color: '#1e3d2f'
              }} data-id="element-2171" />
              </div>
              <h3 className="text-xl font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-2172">
                Family Membership
              </h3>
            </div>
            <div className="mb-6" data-id="element-2173">
              <span className="text-4xl font-bold" style={{
              color: '#1e3d2f'
            }} data-id="element-2174">
                $250.00
              </span>
              <span className="text-sm ml-1" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2175">
                / year
              </span>
            </div>
            <ul className="space-y-3 flex-1" data-id="element-2176">
              <li className="flex items-start gap-2" data-id="element-2177">
                <CheckCircle2Icon size={18} className="mt-0.5 flex-shrink-0" style={{
                color: '#c8a84b'
              }} data-id="element-2178" />
                <span className="text-sm" style={{
                color: '#5a5a5a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-2179">
                  Includes spouse and children under the age of 21
                </span>
              </li>
              <li className="flex items-start gap-2" data-id="element-2180">
                <CheckCircle2Icon size={18} className="mt-0.5 flex-shrink-0" style={{
                color: '#c8a84b'
              }} data-id="element-2181" />
                <span className="text-sm" style={{
                color: '#5a5a5a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-2182">
                  Membership year begins on the date of application approval by
                  the Board of Directors
                </span>
              </li>
            </ul>
          </div>

          {/* Senior Membership */}
          <div className="bg-white rounded-xl p-8 border shadow-sm flex flex-col relative overflow-hidden" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2183">
            <div className="absolute top-0 left-0 right-0 h-1" style={{
            backgroundColor: '#c8a84b'
          }} data-id="element-2184" />
            <div className="flex items-center gap-3 mb-4" data-id="element-2185">
              <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{
              backgroundColor: 'rgba(200,168,75,0.1)'
            }} data-id="element-2186">
                <UserIcon size={24} style={{
                color: '#c8a84b'
              }} data-id="element-2187" />
              </div>
              <h3 className="text-xl font-bold uppercase" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-2188">
                Senior Membership
              </h3>
            </div>
            <div className="mb-6" data-id="element-2189">
              <span className="text-4xl font-bold" style={{
              color: '#1e3d2f'
            }} data-id="element-2190">
                $145.00
              </span>
              <span className="text-sm ml-1" style={{
              color: '#5a5a5a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-2191">
                / year
              </span>
            </div>
            <ul className="space-y-3 flex-1" data-id="element-2192">
              <li className="flex items-start gap-2" data-id="element-2193">
                <CheckCircle2Icon size={18} className="mt-0.5 flex-shrink-0" style={{
                color: '#c8a84b'
              }} data-id="element-2194" />
                <span className="text-sm" style={{
                color: '#5a5a5a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-2195">
                  A reduced cost membership available to all applicants 65 years
                  of age or older at the time of application
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
}